<template>
  <div class="index container">
    <div>
      <v-card elevation="0" outlined class="mt-5">
        <v-sheet class="pa-4 d-md-flex">
          <v-sheet class="flex-sm-column">
            <p class="text-h4 ma-0">Documents</p>
          </v-sheet>

          <v-sheet class="flex-sm-column my-3 my-md-0">
            <v-breadcrumbs class="pa-md-3 pa-0">
              <v-breadcrumbs-item
                :exact="true"
                :to="{ name: 'home', params: {} }"
                >Home</v-breadcrumbs-item
              >
              <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
              <v-breadcrumbs-item
                :exact="true"
                :to="{ name: 'AccountDocuments', params: {} }"
                active
              >
                Account Documents
              </v-breadcrumbs-item>
            </v-breadcrumbs>
          </v-sheet>

          <v-spacer></v-spacer>

          <v-sheet class="flex-sm-column">
            <v-row>
              <v-col cols="12">
                <v-btn
                  class="align-self-end align-self-lg-start text-capitalize"
                  color="primary"
                  block
                  text
                  outlined
                  @click="openDialog"
                >
                  <v-icon>mdi-plus</v-icon>
                  Add Documents
                </v-btn>
              </v-col>
            </v-row>
          </v-sheet>
        </v-sheet>
      </v-card>

      <v-card elevation="0" class="mt-5">
        <v-card-text class="pa-10">
          <v-data-table
            :headers="headers"
            :items="documents"
            class="elevation-1"
          >
            <template v-slot:item.createdAt="{ item }">
              {{ formatDate(item.createdAt) }}
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon @click="editDocument(item)"> mdi-pencil </v-icon>
              <v-icon class="ml-2" @click="deleteDocument(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
    <confirmation-dialog ref="confirm" />
    <v-dialog v-model="dialogVisible" max-width="600px">
      <v-card>
        <v-card-title>
          <v-icon @click="dialogVisible = false" class="ml-auto">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text>
          <AccountDocumentForm
            :key="selectedDocument ? selectedDocument.id:null"
            :initialData="selectedDocument"
            @formSubmitted="submitForm"
            @closeDialog="dialogVisible = false"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
const ConfirmationDialog = () =>
  import("@/components/common/ConfirmationDialog.vue");
import AccountDocumentForm from "@/components/accountDocument/AccountDocumentForm.vue";

export default {
  components: {
    AccountDocumentForm,
    ConfirmationDialog,
  },
  data() {
    return {
      dialogVisible: false,
      headers: [
        { text: "Document Type", value: "documentType" },
        { text: "Last Updated", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      documents: [],
    };
  },
  mounted() {
    this.fetchDocuments();
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
    },
    formatDate(date) {
      return moment(date).format("MMM DD, YYYY");
    },
    async fetchDocuments() {
      try {
        const response = await this.$axios.get("/account-documents");
        this.documents = response.data;
      } catch (error) {
        console.error("An error occurred while fetching data: ", error);
      }
    },
    async submitForm(payload) {
      if (payload.id) {
        this.updateDocument(payload);
      } else {
        this.createDocument(payload);
      }
      await this.fetchDocuments(); // Refresh the document list
    },
    async createDocument(payload) {
      this.$axios.post("/account-documents", payload);

      await this.fetchDocuments(); // Refresh the document list
    },
    async updateDocument(payload) {
      this.$axios.put("/account-documents/" + payload.id, payload);

      await this.fetchDocuments(); // Refresh the document list
    },
    async editDocument(item) {
      this.selectedDocument = Object.assign({}, item); // Clone the item
      this.dialogVisible = true;
    },
    async deleteDocument(item) {
      const confirmed = await this.$refs.confirm.open(
        "Delete Document",
        `Are you sure you want to delete the document of type "${item.documentType}"?`,
        "Yes",
        "No"
      );

      if (confirmed) {
        // Make an API call to delete the document
        // For example: await axios.delete(`/api/accountDocuments/${item.id}`);
        console.log(`Document with ID ${item.id} is deleted.`);

        await this.$axios.delete(`/account-documents/${item.id}`);

        await this.fetchDocuments(); // Refresh the document list
      }
    },
  },
};
</script>

    